"use strict";

angular.module("vendor")
.component("mpttIndustrySelector", {
    bindings: {
        sharedScope: "=",
        selectedIndustries: "="
    },
    templateUrl: require("./mptt-industry-selector.component.html"),
    controller: function($filter, ModalService, common, IndustryService) {
        var _this = this;

        this.openIndustryModal = function() {
            this.isFetching = true;
            IndustryService.queryFilters().$promise.then(function(tree) {

                ModalService.showModal({
                    templateUrl: require("./mptt-industry-selector.modal.html"),
                    controller: "treeIndustrySelectorController",
                    controllerAs: "industrySelectorCtrl",
                    inputs: {
                        $attrs: {
                            tree: tree,
                            selectedIndustries: _this.selectedIndustries
                        },
                        treeOptions: {dirSelectable: true}
                    }
                }).then(function(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                    });
                    modal.close.then(function(result) {
                        if (result) {
                            _this.selectedIndustries.push(result);
                            var industryIds = IndustryService.getFilterIdParameter(_this.selectedIndustries);
                            _this.sharedScope.$emit("industryFilterUpdated", {industries: industryIds});
                        }
                        modal.element.remove();
                    });
                }).finally(function() {
                    _this.isFetching = false;
                });

            });
        };
    }

});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/mptt-industry-selector/mptt-industry-selector.component.js
// module id = 807
// module chunks = 0